import React from 'react';

/**
 * The masthead every detail page opens with: the page's own sentence on the
 * left, a photograph bleeding off the right edge. Each page passes a different
 * picture so the set does not read as one template with the words swapped.
 */
const PageHead = ({ title, image, children }) => (
  <section className="stms-page-head">
    <div
      className="stms-page-head__art"
      style={{ backgroundImage: `url(${image})` }}
      aria-hidden="true"
    />
    <div className="stms-wrap stms-page-head__inner">
      <div className="stms-page-head__say">
        <h1>{title}</h1>
        {children}
      </div>
    </div>
  </section>
);

export default PageHead;
